import { Box, Typography } from "@mui/material";
import RedirectBackButton from "components/RedirectBackButton";
import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import useTrashablePromises from "hooks/useTrashablePromises";
import { FormattedMessage as T, useIntl } from "react-intl";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import {
  IOrganizationSaveRequest,
  OrganizationSaveRequest,
  SaveResponse,
} from "services/KnowfullyAdminClient";
import translateError from "utils/translateError";
import OrganizationForm from "./OrganizationForm";

const OrganizationCreateForm = () => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const {
    organizationService,
    organizationDetailsUrl,
    organizationsUrl,
  } = useGlobalContext();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  useTitle(t({ id: "organizationFormCreateTitle" }));

  const onCancel = () => {
    navigate(organizationsUrl());
  };

  const onSubmit = async (values: IOrganizationSaveRequest) => {
    try {
      const createdOrganization: SaveResponse = await registerPromise(
        organizationService.saveOrganization(
          new OrganizationSaveRequest(values)
        )
      );

      queryClient.invalidateQueries("organizations");
      queryClient.invalidateQueries("organizationService.getOrganizationTree");
      navigate(organizationDetailsUrl(createdOrganization.id));
      return createdOrganization;
    } catch (err: any) {
      console.log(err);
      return { [FORM_ERROR]: translateError(err, t) };
    }
  };

  return (
    <>
      <Box my={2}>
        <RedirectBackButton
          redirectRoute={organizationsUrl()}
          labelKey="backToListButtonLabel"
        />
      </Box>
      <Typography variant="h5">
        <T id="organizationFormCreateTitle" />
      </Typography>
      <OrganizationForm
        onSubmit={onSubmit}
        submitLabel={t({ id: "organizationCreateButton" })}
        onCancel={onCancel}
      />
    </>
  );
};

export default OrganizationCreateForm;
